/**
 * this is css variables
 * --p-blue-500 equal to basePrimitive.blue.500
 * --p-other-orange-500 equal to basePrimitive.other.orange.500
 *
 *
 * sky need to change in to surface
 * --p-sky-500 -> --p-surface-500
 *
 *
 * sky blue to change in to primary
 * --p-blue-500 -> --p-primary-500
 */
// todo: add opacity from existing colors
export const basePrimitive = {
  borderRadius: {
    none: '0',
    xs: '2px',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
  },
  other: {
    blue: {
      40: '#4AD2FF',
      50: '#7EB6D4',
      100: '#02699C',
      105: '#00759B',
      110: '#106E98',
      120: '#015480',
      130: '#024A6F',
      200: '#00304D',
      300: '#4A9BFF',
      500: '#20212C',
      600: '#06072C',
    },
    orange: {
      500: '#F09B1F',
    },
    gray: {
      50: '#F4F4F4', // 50?
      100: '#E1E8ED',
      200: '#A8AAB7',
    },
    red: {
      450: '#DF424F',
      500: '#E12B3A',
    },
    green: {
      500: '#4AA041',
      600: '#2C6D25',
      700: '#1B3A18',
    },
    rose: {
      300: '#ED4A99',
    },
    opacity: {
      neutral: {
        500: {
          50: 'rgba(230, 241, 250, 0.5)',
          70: 'rgba(230, 241, 250, 0.7)',
          80: 'rgba(230, 241, 250, 0.8)',
        },
      },
      gray: {
        100: {
          40: 'rgba(189, 191, 198, 0.4)',
          50: 'rgba(189, 191, 198, 0.5)',
        },
      },
      otherGray: {
        50: {
          50: 'rgba(244, 244, 244, 0.5)',
        },
      },
      slate: {
        50: {
          90: 'rgba(248, 250, 252, 0.90)',
        },
      },
      sky: {
        20: 'rgba(19, 181, 234, 0.2)',
        40: 'rgba(19, 181, 234, 0.4)',
      },
      red: {
        20: 'rgba(199, 31, 48, 0.2)',
      },
      white: {
        90: 'rgba(255, 255, 255, 0.9)',
        80: 'rgba(255, 255, 255, 0.8)',
        60: 'rgba(255, 255, 255, 0.6)',
        40: 'rgba(255, 255, 255, 0.4)',
        15: 'rgba(255, 255, 255, 0.15)',
        8: 'rgba(255, 255, 255, 0.08)',
      },
      orange: {
        25: 'rgba(255, 152, 30, 0.25)',
      },
      black: {
        80: 'rgba(0, 0, 0, 0.8)',
        70: 'rgba(0, 0, 0, 0.7)',
        25: 'rgba(0, 0, 0, 0.25)',
        20: 'rgba(0, 0, 0, 0.2)',
        15: 'rgba(0, 0, 0, 0.15)',
      },
      // box-shadow: 0px 0.25rem 1.5rem 0px rgba(0, 0, 0, 0.2);
    },
  },
  // todo: add transparent color and retest (this is used in native components and do not find in variables list need to retest all components that use this)
  // transparent: 'transparent',
  white: '#FFFFFF',
  black: '#000000',
  green: {
    50: '#f7fcec', // 50
    100: '#dcf2b1', // 75
    200: '#ceed91', // 100
    300: '#b8e561', // 200
    400: '#b8e561', // 200
    500: '#aae041', // 300
    600: '#779d2e', // 300
    700: '#779d2e', // 400
    800: '#688928', // 500
    900: '#688928', // 500
    950: '#688928', // 500
  },
  lime: {
    50: '#f7fcec', // 50
    100: '#dcf2b1', // 75
    200: '#ceed91', // 100
    300: '#b8e561', // 200
    400: '#b8e561', // 200
    500: '#aae041', // 300
    600: '#779d2e', // 300
    700: '#779d2e', // 400
    800: '#688928', // 500
    900: '#688928', // 500
    950: '#688928', // 500
  },
  red: {
    50: '#f9e9ea', //50
    100: '#e8a3aa', // 75
    200: '#df7d87', // 100
    300: '#d14553', // 200
    400: '#d14553', // 200
    500: '#c71f30', // 300
    600: '#8b1622', // 400
    700: '#8b1622', // 400
    800: '#79131d', // 500
    900: '#79131d', // 500
    950: '#79131d', // 500
  },
  orange: {
    50: '#fffae6', // 50
    100: '#fff0b3', // 75
    200: '#ffe280', // 100
    300: '#ffc300', // 200
    400: '#ffc300', // 200
    500: '#ffaa00', // 300
    600: '#ff981e', // 400
    700: '#ff981e', // 400
    800: '#ff8a00', // 500
    900: '#ff8a00', // 500
    950: '#ff8a00', // 500
    550: '#9B5500',
  },
  // surface
  sky: {
    50: '#e7f8fd', // 50
    100: '#9ee1f6', // 75
    200: '#76d4f3', // 100
    300: '#3bc2ee', // 200
    400: '#3bc2ee', // 200
    500: '#13b5ea', // 300
    600: '#0d7fa4', // 400
    700: '#0d7fa4', // 400
    800: '#0c6e8f', // 500
    900: '#0c6e8f', // 500
    950: '#0c6e8f', // 500
  },
  // primary
  blue: {
    50: '#e6eef2', // 50
    100: '#96b9cb', // 75
    200: '#6b9cb6', // 100
    300: '#2b7296', // 200
    400: '#2b7296', // 200
    500: '#005581', // 300
    600: '#003b5a', // 400
    700: '#003b5a', // 400
    800: '#00344f', // 500
    900: '#00344f', // 500
    950: '#00344f', // 500
  },
  violet: {
    50: '#cb55e5', // 100
    100: '#cb55e5', // 100
    200: '#9c43b0', // 200
    300: '#9c43b0', // 200
    400: '#9c43b0', // 200
    500: '#692a77', // 300
    600: '#4a1d53', // 400
    700: '#4a1d53', // 400
    800: '#401a49', // 500
    900: '#401a49', // 500
    950: '#401a49', // 500
  },
  neutral: {
    50: '#f5f9fd', // 200
    100: '#f5f9fd', // 200
    200: '#f5f9fd', // 200
    300: '#f5f9fd', // 200
    400: '#f5f9fd', // 200
    500: '#e6f1fa', // 300
    600: '#a1a9af', // 400
    700: '#a1a9af', // 400
    800: '#8c9399', // 500
    900: '#8c9399', // 500
    950: '#8c9399', // 500
  },
  gray: {
    50: '#efeff1', // 50
    100: '#bdbfc6', // 75
    200: '#a2a4af', // 100
    300: '#7a7d8c', // 200
    400: '#7a7d8c', // 200
    500: '#5f6275', // 300
    600: '#434552', // 400
    700: '#434552', // 400
    800: '#3a3c47', // 500
    900: '#3a3c47', // 500
    950: '#09161D', // 500 // Dark
  },
  emerald: {
    50: '#ecfdf5',
    100: '#d1fae5',
    200: '#a7f3d0',
    300: '#6ee7b7',
    400: '#34d399',
    500: '#10b981',
    600: '#059669',
    700: '#047857',
    800: '#065f46',
    900: '#064e3b',
    950: '#022c22',
  },
  amber: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
    950: '#451a03',
  },
  yellow: {
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04',
    700: '#a16207',
    800: '#854d0e',
    900: '#713f12',
    950: '#422006',
  },
  teal: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#14b8a6',
    600: '#0d9488',
    700: '#0f766e',
    800: '#115e59',
    900: '#134e4a',
    950: '#042f2e',
  },
  cyan: {
    50: '#ecfeff',
    100: '#cffafe',
    200: '#a5f3fc',
    300: '#67e8f9',
    400: '#22d3ee',
    500: '#06b6d4',
    600: '#0891b2',
    700: '#0e7490',
    800: '#155e75',
    900: '#164e63',
    950: '#083344',
  },
  indigo: {
    50: '#eef2ff',
    100: '#e0e7ff',
    200: '#c7d2fe',
    300: '#a5b4fc',
    400: '#818cf8',
    500: '#6366f1',
    600: '#4f46e5',
    700: '#4338ca',
    800: '#3730a3',
    900: '#312e81',
    950: '#1e1b4b',
  },
  purple: {
    50: '#faf5ff',
    100: '#f3e8ff',
    200: '#e9d5ff',
    300: '#d8b4fe',
    400: '#c084fc',
    500: '#a855f7',
    600: '#9333ea',
    700: '#7e22ce',
    800: '#6b21a8',
    900: '#581c87',
    950: '#3b0764',
  },
  fuchsia: {
    50: '#fdf4ff',
    100: '#fae8ff',
    200: '#f5d0fe',
    300: '#f0abfc',
    400: '#e879f9',
    500: '#d946ef',
    600: '#c026d3',
    700: '#a21caf',
    800: '#86198f',
    900: '#701a75',
    950: '#4a044e',
  },
  pink: {
    50: '#fdf2f8',
    100: '#fce7f3',
    200: '#fbcfe8',
    300: '#f9a8d4',
    400: '#f472b6',
    500: '#ec4899',
    600: '#db2777',
    700: '#be185d',
    800: '#9d174d',
    900: '#831843',
    950: '#500724',
  },
  rose: {
    50: '#fff1f2',
    100: '#ffe4e6',
    200: '#fecdd3',
    300: '#fda4af',
    400: '#fb7185',
    500: '#f43f5e',
    600: '#e11d48',
    700: '#be123c',
    800: '#9f1239',
    900: '#881337',
    950: '#4c0519',
  },
  slate: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
    950: '#020617',
  },
  zinc: {
    50: '#fafafa',
    100: '#f4f4f5',
    200: '#e4e4e7',
    300: '#d4d4d8',
    400: '#a1a1aa',
    500: '#71717a',
    600: '#52525b',
    700: '#3f3f46',
    800: '#27272a',
    900: '#18181b',
    950: '#09090b',
  },
  stone: {
    50: '#fafaf9',
    100: '#f5f5f4',
    200: '#e7e5e4',
    300: '#d6d3d1',
    400: '#a8a29e',
    500: '#78716c',
    600: '#57534e',
    700: '#44403c',
    800: '#292524',
    900: '#1c1917',
    950: '#0c0a09',
  },
};
